module.exports = __webpack_public_path__ + "static/media/facebook.37e19df8.svg";